export function store () {
  let _v = 1

  return {
    get value () {
      return _v
    },
    set value (v) {
      _v = v
    }
  }
}

export const flagLandPositionX = store()

export const flagLandSteps = store()
export const winLandPosition = (stepsToWin) => {
  flagLandSteps.value = stepsToWin
}

export const gameMultipliers = store()
export const setGameMultipliers = (m) => {
  gameMultipliers.value = m
}

export const isApiFetching = store()
isApiFetching.value = false

export const isChickenReached = store()
isChickenReached.value = true

export const frogReachedWinLand = store()
frogReachedWinLand.value = false

export const isFrogDie = store()
isFrogDie.value = false

export const isGameStart = store()
isGameStart.value = false

export const clickedLeaf = store()
clickedLeaf.value = false
